import { css } from '@emotion/react';

export const multiselectStyles = {
  wrapper: css`
    width: 650px;
  `,
  cardWrapper: css`
    display: flex;
    height: 420px;
  `,
  selectCard: css`
    width: 100%;
    height: 100%;
    overflow-y: auto;
    margin: 8px;
  `,
  centerSection: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 8px 0;
    height: 100%;
  `,
  middleButton: css`
    margin-bottom: 4px;
  `,
  itemTitle: css`
    padding-left: 10px;
  `,
};
